exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vc-notice.vc-notice--pre-wrap[data-v-678cfbed]{white-space:pre-wrap}.vc-notice ol[data-v-678cfbed],.vc-notice ul[data-v-678cfbed]{padding-left:1rem}.vc-notice h4[data-v-678cfbed]{font-size:1.2rem}", ""]);

// exports
